import Profile from 'common/domain/models/profile';
import FoodBenefitUser from 'common/domain/models/foodBenefitUser';
import ERRORS from 'common/errors/formatter.errors';
import catchAndThrow from 'common/errors/error.utils';
import cardRowDataFormatter from 'food-benefit.module/common/domain/formatters/cardRowDataFormatter';
import delegationsFormatter from 'food-benefit.module/common/domain/formatters/delegationsFormatter';

function assembleProfile(data) {
  let profile = new Profile();
  profile.name = data.name;
  profile.userId = data.employeeId;
  profile.image = data.image;
  profile.email = data.email;
  profile.delegation = data.delegations;
  profile.employeeopplus = data.employeeopplus;

  if(data.bbvaUserId) {
    profile.bbvaUserId = data.bbvaUserId;
  }

  if (data.manager) {
    profile.role = Profile.ROLE_MANAGER;
  }

  return profile;
}

class employeeDataAssembler {
  static assemble(userId, data) {
    let profile;
    catchAndThrow(() => { profile = assembleProfile(data.employeeProfile); }, ERRORS.ASSEMBLE_PROFILE);
    let user = new FoodBenefitUser(userId, profile);
    user.cards = cardRowDataFormatter.assemble(data);
    const rawDelegations = data.delegations || [];
    user.delegations = delegationsFormatter.assemble(rawDelegations);
    return user;
  }
}

export default employeeDataAssembler;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/employeeRepository/employeeRepository.assemblers.js